import React from 'react';
import { motion } from 'framer-motion';
const bonuses = [{
  badge: 'Bono 1',
  title: '🚨 Emergencias Emocionales en la Adolescencia',
  description: 'Guía de acción rápida para cuando tu hijo está en crisis y no sabes qué hacer. Protocolos paso a paso para los momentos más difíciles: ansiedad, depresión, conflictos agudos, automedicación y más.',
  value: 'Valorado en $17.99 GRATIS para ti'
}, {
  badge: 'Bono 2',
  title: '💜 Amor Propio y Salud Mental en la Adolescencia',
  description: 'Cómo cultivar la autoestima de tu hijo y proteger su bienestar emocional desde casa. Estrategias para construir una identidad sólida en un mundo que amenaza constantemente la autoestima adolescente.',
  value: 'Valorado en $17.99 GRATIS para ti'
}];
export function BonusesSection() {
  return <section className="bg-gradient-to-br from-[#F4A535] to-[#E8851A] py-20 px-5 text-center" data-id="element-23">
      <div className="max-w-5xl mx-auto" data-id="element-24">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-25">
          <div className="inline-block bg-[#1A2744] text-[#F4A535] text-xs font-bold tracking-[2px] uppercase px-5 py-2 rounded-full mb-4" data-id="element-26">
            🎁 Bonus exclusivos
          </div>

          <h2 className="text-3xl md:text-4xl lg:text-5xl text-[#1A2744] mb-4" data-id="element-27">
            Porque Criar No Tiene Que Ser una Crisis Permanente
          </h2>

          <p className="text-lg text-[#4A3010] max-w-2xl mx-auto mb-12" data-id="element-28">
            Con tu guía recibes también estos dos complementos diseñados para
            los momentos más difíciles.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-29">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-white rounded-3xl p-9 shadow-[0_10px_40px_rgba(0,0,0,0.15)]" data-id="element-30">
              <div className="inline-block bg-[#1A2744] text-[#F4A535] text-xs font-bold tracking-[2px] uppercase px-4 py-2 rounded-full mb-4" data-id="element-31">
                {bonus.badge}
              </div>
              <h3 className="text-xl font-bold text-[#1A2744] mb-3" data-id="element-32">
                {bonus.title}
              </h3>
              <p className="text-sm text-[#718096] leading-relaxed mb-4" data-id="element-33">
                {bonus.description}
              </p>
              <div className="text-sm font-bold text-[#F4A535] mt-4" data-id="element-34">
                {bonus.value}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}